import Styled from "styled-components/macro";
import { ellipsis } from "polished";

const Label = Styled.label`
  ${ellipsis()}
  display: block;
  font-size: 1.4rem;
  font-weight: 600;
  color: inherit;
  margin: 0 0 1rem 0;

  ${(props) =>
    props.disabled &&
    `
    opacity: 0.5;
  `}
`;

export default Label;
